import {useMutation} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {ReportResult} from "../../../../types/ReportResult";

export const usePrintInternalCost = (quoteID: number) => {

    const {mutateAsync, isLoading} = useMutation({
        mutationFn: async ({password}: { password: string }) => {
            return await apiClient.post('/estimate/print-internal-cost', {
                quoteID,
                password
            }) as ReportResult;
        }
    });

    return {
        mutateAsync, isLoading
    }
}
